import { apiFetch } from './client';
export async function listCanonicalTeams(tribe) {
    const data = await apiFetch(`/canonical-teams?tribe=${encodeURIComponent(tribe)}`);
    return data.items;
}
export async function createTeam(boardId, canonicalTeamId, nameOverride) {
    return apiFetch(`/boards/${boardId}/teams`, {
        method: 'POST',
        body: JSON.stringify({
            canonicalTeamId,
            ...(nameOverride ? { nameOverride } : {}),
        }),
    });
}
export async function createSection(teamId, name, kind = 'projects') {
    return apiFetch(`/teams/${teamId}/sections`, {
        method: 'POST',
        body: JSON.stringify({ name, kind }),
    });
}
